interface ThumbCardProps {
  thumb: string;
  value: string;
  className?: string;
  fullSize?: boolean;
  altText: string;
}

function ThumbCard(props: ThumbCardProps) {
  return (
    <div className={`${props.className} h-full`}>
      <div className="relative z-0 rounded-[8px] overflow-hidden h-full">
        <img className="w-full h-full object-cover" src={props.thumb} alt={props.altText} />

        {props.value && props.value.length > 0 && (
          <div className="max-w-[80%] px-3 py-1 w-max absolute bottom-3 right-3 opacity-75 bg-indigo-950 rounded-[8px] paragraph-small-regular text-white truncate">
            {props.value}
          </div>
        )}
        {props.value && props.value.length > 0 && props.fullSize && (
          <div className="px-3 py-1 w-max absolute bottom-3 left-3 opacity-75 bg-indigo-950 rounded-[8px] font-medium paragraph-small-regular text-white">
            {props.value}
          </div>
        )}
      </div>
    </div>
  );
}

export default ThumbCard;
